/* JAZMA storefront behaviour.
   Progressive enhancement only. The radios and selects are real form fields and
   /cart is a real page, so every purchase path works with JavaScript disabled.
   JS shortens the path: it matches size × bundle to a variant, reveals the extra
   size pickers, and confirms the add in a drawer instead of a page load. */
(function () {
  'use strict';

  // Only now is the <select> redundant. Setting this in CSS or Liquid would hide
  // the real control from anyone whose JS never runs.
  document.documentElement.classList.add('jz-js');

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var optionLabels = {};
  try {
    var labels = JSON.parse(document.body.getAttribute('data-option-labels') || '{}');
    if (labels && typeof labels === 'object' && !Array.isArray(labels)) optionLabels = labels;
  } catch (e) { /* Raw option values remain a safe display fallback. */ }
  function optionLabel(value) {
    return Object.prototype.hasOwnProperty.call(optionLabels, value) && typeof optionLabels[value] === 'string'
      ? optionLabels[value] : value;
  }
  var root = document.body.getAttribute('data-root-url') ||
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function cartUrl(suffix) { return root.replace(/\/?$/, '/') + 'cart' + (suffix || ''); }
  function readCart() {
    return fetch(cartUrl('.js'), { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart unavailable'); return r.json(); })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) throw new Error('invalid cart');
        return cart;
      });
  }
  function addCartItem(body) {
    return fetch(cartUrl('/add.js'), { method: 'POST', headers: { Accept: 'application/json' }, body: body })
      .then(function (r) {
        if (r.ok) return;
        return r.json().catch(function () { return {}; }).then(function (data) {
          var err = new Error(data && typeof data.description === 'string' ? data.description : '');
          err.addFailed = true;
          throw err;
        });
      });
  }
  // Use the SHOP's money format, not Intl. Intl rendered "‏٨٥٠ ج.م.‏" next to
  // server-rendered "LE 850" — the drawer disagreed with every other price on
  // the page, right at the confirmation moment.
  var money = function (cents) {
    var n = Math.round(cents / 100);
    var grouped;
    try { grouped = n.toLocaleString('en-US'); } catch (e) { grouped = String(n); }
    var fmt = document.body.getAttribute('data-money-format') || 'LE {{amount}}';
    return fmt.replace(/\{\{\s*amount(_no_decimals)?(_with_comma_separator)?\s*\}\}/g, grouped);
  };

  /* ---------------- announce ---------------- */
  var live;
  function announce(msg) {
    if (!msg) return;
    if (!live) {
      live = document.createElement('p');
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      live.className = 'visually-hidden';
      document.body.appendChild(live);
    }
    setTimeout(function () { live.textContent = msg; }, 60);
  }

  /* ---------------- cart drawer ---------------- */
  var drawer = $('#jz-drawer');

  function renderDrawer(cart) {
    if (!drawer) return;
    var body = $('[data-drawer-body]', drawer);
    var foot = $('[data-drawer-foot]', drawer);
    var empty = $('[data-drawer-empty]', drawer);
    $$('.jz-dline', body).forEach(function (n) { n.remove(); });
    $$('[data-cart-stock-notice]', body).forEach(function (n) { n.remove(); });

    if (!cart.items.length) {
      if (empty) empty.hidden = false;
      if (foot) foot.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    if (foot) foot.hidden = false;

    cart.items.forEach(function (it) {
      var row = document.createElement('div');
      row.className = 'jz-dline';
      var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') +
                '" alt="" width="64" height="80" class="jz-dline__img" loading="lazy">' : '';
      // textContent for anything from the cart — never innerHTML a product title
      row.innerHTML = img + '<div class="jz-dline__body">' +
        '<span class="jz-dline__name"></span>' +
        '<span class="jz-dline__opt"></span>' +
        '<span class="jz-dline__price"></span></div>';
      $('.jz-dline__name', row).textContent = it.handle === 'جزمة-jazma'
        ? document.body.getAttribute('data-jazma-title') || it.product_title : it.product_title;
      var opts = (it.options_with_values || []).map(function (o) { return optionLabel(o.value); });
      (it.properties ? Object.keys(it.properties) : []).forEach(function (k) {
        if (k.charAt(0) !== '_' && it.properties[k]) opts.push(optionLabel(k) + ': ' + optionLabel(it.properties[k]));
      });
      $('.jz-dline__opt', row).textContent = opts.join(' · ');
      $('.jz-dline__price', row).textContent = it.quantity + ' × ' + money(it.final_price);
      body.appendChild(row);
    });
    var total = $('[data-drawer-total]', drawer);
    if (total) total.textContent = money(cart.total_price);
  }

  function openDrawer() {
    if (!drawer || typeof drawer.showModal !== 'function') { window.location.href = cartUrl(); return; }
    if (!drawer.open) drawer.showModal();
  }
  if (drawer) {
    $$('[data-drawer-close]', drawer).forEach(function (b) {
      b.addEventListener('click', function () { drawer.close(); });
    });
    // click on the backdrop, i.e. outside the panel
    drawer.addEventListener('click', function (e) { if (e.target === drawer) drawer.close(); });
  }
  $$('[data-cart-open]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (!drawer || typeof drawer.showModal !== 'function') return; // let the link work
      e.preventDefault();
      readCart()
        .then(function (c) { renderDrawer(c); openDrawer(); })
        .catch(function () { window.location.href = a.href; });
    });
  });

  /* ---------------- group orders (اطلبوا مع بعض) ---------------- */
  // The group is usually created while the cart is still EMPTY, and Shopify
  // does not keep attributes on a cart with no line items — so the جروب-كود
  // written at creation silently disappears before checkout. group-watch.py
  // then sees a group order with a name but no code and can never mint the
  // friends' discount. Observed live on order #1002 (جروب "Ana", code gone).
  // Fix: remember the pair locally and re-assert it after every successful add.
  var groupDiscountsEnabled = document.body.getAttribute('data-group-discounts-enabled') === 'true';
  var staleGroupAttributes = document.body.getAttribute('data-group-attributes-present') === 'true';
  var JZ_GKEY = 'jz-group';
  var activeGroup;
  var groupWrites = Promise.resolve();
  var groupCleanup;
  function validGroup(group) {
    if (!group || typeof group.name !== 'string') return null;
    var name = group.name.trim();
    if (!name || name.length > 40) return null;
    var code = typeof group.code === 'string' && /^GROUP-[A-Z0-9]{4,12}$/.test(group.code) ? group.code : null;
    if (group.role === 'joiner') code = null;
    return { name: name, code: code, role: code ? 'creator' : 'joiner' };
  }
  function saveGroup(name, code) {
    activeGroup = validGroup({ name: name, code: code });
    try { localStorage.setItem(JZ_GKEY, JSON.stringify(activeGroup)); }
    catch (e) { /* Keep the current-page state when storage is unavailable. */ }
  }
  function loadGroup() {
    if (activeGroup !== undefined) return activeGroup;
    try { activeGroup = validGroup(JSON.parse(localStorage.getItem(JZ_GKEY) || 'null')); }
    catch (e) { activeGroup = null; }
    return activeGroup;
  }
  function writeGroupAttrs(group) {
    var fd = new FormData();
    fd.append('attributes[جروب]', group ? group.name : '');
    // Shopify retains omitted attributes. A joiner must explicitly remove a
    // previous creator's code so their order cannot mint another group.
    fd.append('attributes[جروب-كود]', group && group.code || '');
    groupWrites = groupWrites.catch(function () {}).then(function () {
      return fetch(cartUrl('/update.js'), { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
        .then(function (r) { if (!r.ok) throw new Error('group update failed'); });
    });
    return groupWrites;
  }
  function postGroupAttrs(name, code) {
    var group = groupDiscountsEnabled && validGroup({ name: name, code: code });
    return group ? writeGroupAttrs(group) : Promise.resolve();
  }
  function clearGroupAttrs() {
    if (!staleGroupAttributes) return Promise.resolve();
    if (groupCleanup) return groupCleanup;
    // Clear only our referral metadata. Do not touch discounts, line items,
    // delivery notes, or another cart attribute.
    groupCleanup = writeGroupAttrs(null).then(function () {
      staleGroupAttributes = false;
    }, function (err) {
      groupCleanup = null;
      throw err;
    });
    return groupCleanup;
  }
  function persistGroup() {
    if (!groupDiscountsEnabled) return clearGroupAttrs();
    var group = loadGroup();
    return group ? postGroupAttrs(group.name, group.code) : Promise.resolve();
  }
  var gsec = $('[data-group]');
  (function () {
    if (!groupDiscountsEnabled) {
      activeGroup = null;
      try { localStorage.removeItem(JZ_GKEY); } catch (e) { /* Ignore stale storage when disabled. */ }
      if (gsec) gsec.hidden = true;
      clearGroupAttrs().catch(function () { /* Retry after add; native cart posts also clear these fields. */ });
      return;
    }
    // A group query can identify metadata, but cannot prove that Shopify has
    // accepted a discount. Do not render a discount-success banner from it.
    var params = new URLSearchParams(location.search);
    var gname = (params.get('group') || '').trim();
    if (gname && gname.length <= 40) {
      var mine = loadGroup();
      // Only our creator checkout link carries this marker. Matching the group
      // name alone mistakes a different group with the same name for our own.
      var ownCode = mine && mine.role === 'creator' && mine.name === gname &&
        mine.code === params.get('group_owner') ? mine.code : null;
      saveGroup(gname, ownCode);
      postGroupAttrs(gname, ownCode).catch(function () { /* Retried after add. */ });
    }
    if (!gsec) return;
    var gform = $('[data-group-create]', gsec);
    var share = $('[data-group-share]', gsec);
    if (!gform || !share) return;
    gform.addEventListener('submit', function (e) {
      e.preventDefault();
      var name = gform.gname.value.trim();
      if (!name || name.length > 30) return;
      // Reserve the friends' code now. The post-order process creates the
      // actual discount and delivers its share link after the creator buys.
      var rand = new Uint8Array(3);
      var alphabet = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';
      (window.crypto || {getRandomValues: function (a) {
        for (var i = 0; i < a.length; i++) a[i] = Date.now() % 251 + i;
      }}).getRandomValues(rand);
      var gcode = 'GROUP-' + Array.prototype.map.call(rand, function (b) {
        return alphabet[b % alphabet.length];
      }).join('') + 'X';
      // Shopify decodes ?redirect= exactly ONCE and 302s to the result.
      // product.url already carries the percent-encoded Arabic handle, so
      // re-encoding the whole thing 404s (%25D8...). Encode only the
      // structural characters and the group value itself.
      var redirect = (gsec.dataset.target || '/') +
        '%3Fgroup%3D' + encodeURIComponent(name);
      var selfLink = location.origin + '/discount/' +
        encodeURIComponent(gsec.dataset.code || '') + '?redirect=' + redirect +
        '%26group_owner%3D' + encodeURIComponent(gcode);
      $('[data-group-ready]', gsec).textContent =
        (gsec.dataset.readyMsg || '').replace('%name%', name);
      var wa = $('[data-group-wa]', gsec);
      // The friends' code is not live yet. Its usable share link is delivered
      // after the creator's order by the existing post-order process.
      if (wa) { wa.hidden = true; wa.removeAttribute('href'); }
      var copyBtn = $('[data-group-copy]', gsec);
      if (copyBtn) { copyBtn.hidden = true; copyBtn.disabled = true; }
      $('[data-group-self]', gsec).href = selfLink;
      saveGroup(name, gcode);
      postGroupAttrs(name, gcode).catch(function () { /* Retried after add. */ });
      gform.hidden = true;
      share.hidden = false;
      announce($('[data-group-ready]', gsec).textContent);
    });
  })();

  /* ---------------- quick add from cards ----------------
     The reveal + quick-add blocks sit BEFORE the buy-form guard below:
     `if (!form) return` ends the IIFE on every non-product page. */
  function addToCart(id, done, fail) {
    var fd = new FormData();
    fd.append('id', id);
    fd.append('quantity', 1);
    addCartItem(fd)
      .then(persistGroup)
      .then(readCart)
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        if (done) done();
        renderDrawer(cart);
        openDrawer();
      })
      .catch(function (err) {
        // A network failure may happen AFTER Shopify accepted the item. Never
        // repeat the add; the real cart resolves that uncertainty safely.
        if (!err.addFailed) { window.location.href = cartUrl(); return; }
        if (fail) fail(err);
      });
  }

  $$('[data-qadd]').forEach(function (qa) {
    var toggle = $('[data-qadd-toggle]', qa);
    var panel  = $('[data-qadd-panel]', qa);
    var adding = false;
    var unavailableNote = $('[data-qadd-note]', qa);
    var unavailableText = unavailableNote ? unavailableNote.textContent : '';
    var vs = [];
    try { vs = JSON.parse($('[data-qadd-variants]', qa).textContent); } catch (e) { vs = []; }

    function close() {
      if (!panel) return;
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    }
    function add(id) {
      if (adding) return;
      adding = true;
      qa.setAttribute('aria-busy', 'true');
      $$('button', qa).forEach(function (button) { button.disabled = true; });
      function release() {
        adding = false;
        qa.removeAttribute('aria-busy');
        $$('button', qa).forEach(function (button) { button.disabled = false; });
      }
      addToCart(id,
        function () { release(); close(); toggle.focus(); },
        function (err) {
          release();
          var note = $('[data-qadd-note]', qa);
          if (note) {
            note.textContent = err.message || note.textContent;
            note.hidden = false;
            announce(note.textContent);
          } else window.location.href = qa.dataset.url;
        });
    }

    toggle.addEventListener('click', function () {
      if (!panel) {
        if (vs.length && vs[0].a) add(vs[0].id);
        else window.location.href = qa.dataset.url;
        return;
      }
      panel.hidden = !panel.hidden;
      toggle.setAttribute('aria-expanded', String(!panel.hidden));
    });

    if (panel) panel.addEventListener('click', function (e) {
      if (adding) return;
      var b = e.target.closest('[data-qadd-opt]');
      if (!b) return;
      $$('[data-qadd-opt][data-group="' + b.dataset.group + '"]', panel).forEach(function (o) {
        o.classList.remove('is-on');
        o.setAttribute('aria-pressed', 'false');
      });
      b.classList.add('is-on');
      b.setAttribute('aria-pressed', 'true');

      var groups = $$('.jz-qadd__group', panel);
      var note = $('[data-qadd-note]', panel);
      var want = groups.map(function (g) {
        var on = $('.is-on', g);
        return on ? on.dataset.value || on.textContent.trim() : null;
      });
      // an option is dead when no AVAILABLE variant carries it plus every
      // value already picked in the OTHER groups — cross it out, keep it
      // clickable so the shopper can still switch paths
      groups.forEach(function (g, gi) {
        $$('[data-qadd-opt]', g).forEach(function (o) {
          var probe = want.slice();
          probe[gi] = o.dataset.value || o.textContent.trim();
          var alive = vs.some(function (v) {
            if (!v.a) return false;
            return probe.every(function (w) { return w === null || v.o.indexOf(w) > -1; });
          });
          o.classList.toggle('is-off', !alive);
        });
      });
      if (note) { note.textContent = unavailableText; note.hidden = true; }
      if (want.indexOf(null) > -1) return; // not everything picked yet
      var match = null;
      vs.forEach(function (v) {
        if (match || !v.a) return;
        var ok = want.every(function (w) { return v.o.indexOf(w) > -1; });
        if (ok) match = v;
      });
      if (match) add(match.id);
      else if (note) note.hidden = false; // picked combo exists but is sold out
    });
  });
  // tap-away closes any open picker
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-qadd]')) return;
    $$('[data-qadd-panel]').forEach(function (pnl) {
      if (!pnl.hidden) {
        pnl.hidden = true;
        var t = $('[data-qadd-toggle]', pnl.closest('[data-qadd]'));
        if (t) t.setAttribute('aria-expanded', 'false');
      }
    });
  });

  /* ---- scroll reveal (enhancement only) ---- */
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.jz-promises > *, .jz-details__grid > *, .jz-faq details, .jz-pay__method, .jz-card, .jz-bundle, .jz-news > *')
      .forEach(function (el, i) {
        el.classList.add('jz-reveal');
        el.style.transitionDelay = (i % 4) * 70 + 'ms';
        io.observe(el);
      });
  }

  // Keep counters synchronized for buttons, swipe, keyboard and colour choices.
  function updateGalleryStatus() {
    var radios = $$('.jz-gallery__radio');
    var count = $('[data-gallery-count]');
    var selected = radios.findIndex(function (r) { return r.checked; });
    if (count) count.textContent = (selected + 1) + ' / ' + radios.length;
  }
  (function () {
    var gal = $('[data-gallery]');
    var radios = $$('.jz-gallery__radio');
    if (!gal || radios.length < 2) return;
    var controls = $('[data-gallery-controls]', gal);
    if (controls) controls.hidden = false;
    function move(step) {
      var current = radios.findIndex(function (r) { return r.checked; });
      radios[(current + step + radios.length) % radios.length].checked = true;
      updateGalleryStatus();
    }
    var prev = $('[data-gallery-prev]', gal), next = $('[data-gallery-next]', gal);
    if (prev) prev.addEventListener('click', function () { move(-1); });
    if (next) next.addEventListener('click', function () { move(1); });
    gal.addEventListener('change', updateGalleryStatus);
    updateGalleryStatus();
  })();

  /* ---------------- gallery swipe (mobile) ----------------
     The thumbnail strip is hidden on phones to buy back vertical space, so
     swipe has to work or the other frames become unreachable. Dots remain the
     accessible, tappable fallback. */
  (function () {
    var stage = $('.jz-gallery__stage');
    if (!stage) return;
    var radios = $$('.jz-gallery__radio');
    if (radios.length < 2) return;
    var x0 = null, y0 = null;
    stage.addEventListener('touchstart', function (e) {
      if (e.target.closest('[data-gallery-toggle]')) return;
      x0 = e.changedTouches[0].clientX; y0 = e.changedTouches[0].clientY;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      // ignore vertical scrolls and stray taps
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      var i = radios.findIndex(function (r) { return r.checked; });
      if (i < 0) i = 0;
      // in RTL a leftward swipe should advance, same as the reading direction
      var rtl = document.documentElement.getAttribute('dir') === 'rtl';
      var forward = rtl ? dx > 0 : dx < 0;
      var next = forward ? i + 1 : i - 1;
      if (next < 0) next = radios.length - 1;
      if (next >= radios.length) next = 0;
      radios[next].checked = true;
      updateGalleryStatus();
    }, { passive: true });
  })();

  function syncMotionButton(button, playing) {
    if (!button) return;
    button.setAttribute('aria-label', playing ? button.dataset.pauseLabel : button.dataset.playLabel);
    $$('[data-motion-pause]', button).forEach(function (icon) {
      if (playing) icon.removeAttribute('hidden'); else icon.setAttribute('hidden', '');
    });
    $$('[data-motion-play]', button).forEach(function (icon) {
      if (playing) icon.setAttribute('hidden', ''); else icon.removeAttribute('hidden');
    });
  }

  /* ---------------- announcement pause/play ---------------- */
  (function () {
    var bar = $('.jz-announce--marquee');
    if (!bar) return;
    var button = $('[data-announce-toggle]', bar);
    if (!button || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    button.addEventListener('click', function () {
      bar.classList.toggle('is-paused');
      syncMotionButton(button, !bar.classList.contains('is-paused'));
    });
    syncMotionButton(button, true);
    button.hidden = false;
  })();

  /* ---------------- gallery autoplay ----------------
     Starts only when the shopper selects Play. Stops when they take over (dot, thumb,
     swipe, keyboard), pauses while hovered / touched / focused, pauses in a
     background tab, and never runs for reduced-motion users. */
  (function () {
    var gal = $('[data-gallery]');
    var radios = $$('.jz-gallery__radio');
    if (!gal || radios.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var button = $('[data-gallery-toggle]', gal);
    var EVERY = 4500, timer = null, stopped = false, hovered = false, focused = false;
    function advance() {
      if (stopped || hovered || focused || document.hidden) return;
      var i = radios.findIndex(function (r) { return r.checked; });
      radios[(i + 1) % radios.length].checked = true;
      updateGalleryStatus();
    }
    function start() {
      stopped = false;
      if (!timer) timer = setInterval(advance, EVERY);
      syncMotionButton(button, true);
    }
    function stop() {
      stopped = true;
      if (timer) { clearInterval(timer); timer = null; }
      syncMotionButton(button, false);
    }
    // any deliberate choice ends autoplay — a slideshow that fights the
    // shopper's own selection is worse than none
    gal.addEventListener('change', function (e) { if (e.isTrusted) stop(); });
    $$('.jz-gallery__dot, .jz-gallery__thumb, [data-gallery-prev], [data-gallery-next]', gal).forEach(function (el) {
      el.addEventListener('click', stop);
    });
    gal.addEventListener('touchstart', function (e) {
      if (!e.target.closest('[data-gallery-toggle]')) stop();
    }, { passive: true });
    gal.addEventListener('mouseenter', function () { hovered = true; });
    gal.addEventListener('mouseleave', function () { hovered = false; });
    gal.addEventListener('focusin',  function () { focused = true; });
    gal.addEventListener('focusout', function (e) { if (!gal.contains(e.relatedTarget)) focused = false; });
    if (button) {
      button.addEventListener('click', function () {
        if (!stopped) stop();
        else { hovered = false; focused = false; start(); }
      });
      button.hidden = false;
    }
    stop(); // Product photography stays still until the shopper requests a slideshow.
  })();

  /* ---------------- language switcher ---------------- */
  $$('[data-lang-switch]').forEach(function (grp) {
    $$('[data-locale]', grp).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-on')) return;
        // this store's default (Arabic) lives at the bare path; every other
        // published language is prefixed with /<iso-code> — confirmed live,
        // /localization (Shopify's normal POST endpoint) 404s here regardless
        var path = location.pathname.replace(/^\/(ar|en)(\/|$)/, '/');
        var target = btn.dataset.locale === 'ar' ? path : '/' + btn.dataset.locale + path;
        location.href = target.replace(/\/{2,}/g, '/') + location.search + location.hash;
      });
    });
  });

  /* ---------------- buy form ---------------- */
  /* ---------------- cart page: stepper + remove without a reload ----------------
     −/+ and remove post to /cart/change.js, then the cart section is re-rendered
     from Shopify's own markup (Section Rendering API) so prices, subtotal and
     the bundle notes stay exactly what Liquid would print. No JS: the number
     input still posts as updates[] and remove is a plain link. */
  (function () {
    var cartSection = $('.jz-cart');
    if (!cartSection) return;
    var busy = false;

    function bind() {
      var cartForm = $('.jz-cart__form', cartSection);
      if (!cartForm) return;
      var quantities = $$('input[name="updates[]"]', cartForm);
      quantities.forEach(function (input) { input.required = true; input.min = '0'; input.step = '1'; });
      cartForm.addEventListener('submit', function (e) {
        // Update skips the policy checkbox, but must still reject blank,
        // fractional or negative quantities before posting to Shopify.
        var invalid = quantities.find(function (input) { return !input.checkValidity(); });
        if (invalid) { e.preventDefault(); invalid.focus(); invalid.reportValidity(); }
      });
      $$('[data-step]', cartForm).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var wrap = btn.closest('[data-line]');
          var input = $('[data-qty]', wrap);
          var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.step, 10));
          change(parseInt(wrap.dataset.line, 10), next, wrap);
        });
      });
      $$('[data-qty]', cartForm).forEach(function (input) {
        input.addEventListener('change', function () {
          var wrap = input.closest('[data-line]');
          change(parseInt(wrap.dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0), wrap);
        });
      });
      $$('[data-remove]', cartForm).forEach(function (a) {
        a.addEventListener('click', function (e) {
          if (!window.fetch) return;              // let the link navigate
          e.preventDefault();
          change(parseInt(a.closest('[data-line]').dataset.line, 10), 0, a.closest('[data-line]'));
        });
      });
    }

    function change(line, quantity, wrap) {
      if (busy || !window.fetch) return;
      busy = true;
      if (wrap) wrap.classList.add('is-busy');
      var body = new FormData();
      body.append('line', String(line));
      body.append('quantity', String(quantity));
      fetch(cartUrl('/change.js'), { method: 'POST', body: body, headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('change failed'); return r.json(); })
        .then(function (cart) {
          $$('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count; el.hidden = cart.item_count === 0;
          });
          // empty cart: the section swaps to its empty state — take the whole page
          if (cart.item_count === 0) { location.reload(); return; }
          // The Section Rendering API wants the section's full id
          // (template--…__main — a bare "main" is a 404), and the request has
          // to stay inside the current locale, or the /en page would swap an
          // Arabic cart into an English one.
          var sid = cartSection.dataset.sectionId || 'main';
          return fetch(cartUrl('?section_id=' + encodeURIComponent(sid)))
            .then(function (r) { if (!r.ok) throw new Error('section failed'); return r.text(); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var fresh = doc.querySelector('.jz-cart');
              if (!fresh) { location.reload(); return; }
              cartSection.innerHTML = fresh.innerHTML;
              bind();
              announce(cartSection.dataset.updatedMsg || '');
            });
        })
        .catch(function () { location.reload(); })   // Shopify's own page is the fallback
        .then(function () { busy = false; });
    }

    bind();
  })();
  var form = $('#jz-buy-form');
  if (!form) return;
  var section = $('[data-buy]');
  var variants = [];
  try { variants = JSON.parse($('[data-variants]', section).textContent); } catch (e) { variants = []; }
  if (!Array.isArray(variants) || !variants.length) return;

  var idField   = $('[data-variant-select]', form);
  var priceEls  = $$('[data-price]', section);
  var cta       = $('[data-cta]', form);
  var extra     = $('[data-extra]', form);
  var singleStockBundles = section.dataset.singleStockBundles === 'true';
  var stickyBar = $('[data-sticky-buy]', section);
  var stickyCta = $('[data-cta-sticky]', section);
  var touched   = false;
  var addPending = false;
  var cartError = $('[data-cart-error]', form);
  function showAddError(message) {
    if (!cartError) {
      cartError = document.createElement('p');
      cartError.className = 'jz-field__note';
      cartError.setAttribute('data-cart-error', '');
      cartError.setAttribute('role', 'alert');
      form.appendChild(cartError);
    }
    cartError.textContent = message || form.dataset.errorMsg || '';
    cartError.hidden = false;
  }
  var basePrice = priceEls.length ? priceEls[0].textContent.trim() : '';

  function chosen(name) {
    var r = form.querySelector('input[name="' + name + '"]:checked');
    return r ? r.value : null;
  }

  function selectedPairs() {
    var input = form.querySelector('input[name="opt-bundle"]:checked');
    var label = input && input.closest('[data-pairs]');
    return label ? parseInt(label.dataset.pairs, 10) : 1;
  }

  function hasStock(variant, quantity) {
    return !!variant && variant.available && (!variant.inventoryManaged || variant.continueSelling ||
      Number(variant.inventoryQuantity) >= quantity);
  }

  function singleVariant(size, color) {
    return variants.find(function (v) {
      return v.pairs === 1 && v.size === size && (!color || v.color === color);
    }) || null;
  }

  function secondPair() {
    var row = extra && $('[data-extra-row="2"]', extra);
    var size = row && $('[data-extra-kind="size"]', row);
    var color = row && $('[data-extra-kind="color"]', row);
    return { size: size && size.value, color: color && color.value,
      missing: !size || !size.value || !!(color && !color.value) };
  }

  function bundleSelection() {
    var second = secondPair();
    var first = singleVariant(chosen('opt-size'), chosen('opt-color'));
    var next = second.missing ? null : singleVariant(second.size, second.color);
    var available = !second.missing && hasStock(first, next && first && next.id === first.id ? 2 : 1) && hasStock(next, 1);
    return { first: first, second: next, missing: second.missing, available: available };
  }

  function match() {
    // Every option group that is actually RENDERED must have a value. Matching
    // on a partial selection returned the first variant carrying, say, the
    // chosen bundle — an arbitrary size — and the page then priced it, enabled
    // the button and hid the "choose a size" note, presenting a ready buy box
    // for a size nobody picked.
    var groups = ['opt-color', 'opt-size', 'opt-bundle'].filter(function (n) {
      return !!form.querySelector('input[name="' + n + '"]');
    });
    if (groups.some(function (n) { return !chosen(n); })) return null;
    var want = groups.map(chosen);
    return variants.find(function (v) {
      return want.every(function (w) { return v.options.indexOf(w) !== -1; });
    }) || null;
  }

  function syncExtra() {
    if (!extra) return;
    var label = form.querySelector('input[name="opt-bundle"]:checked');
    var wrap = label ? label.closest('[data-pairs]') : null;
    var pairs = wrap ? parseInt(wrap.dataset.pairs, 10) : 1;
    extra.hidden = !(pairs > 1);
    $$('[data-extra-row]', extra).forEach(function (row) {
      var n = parseInt(row.dataset.extraRow, 10);
      var on = n <= pairs;
      row.hidden = !on;
      // a disabled select is not submitted — that is what keeps the cart clean
      $$('[data-extra-select]', row).forEach(function (sel) { sel.disabled = !on; });
    });
  }

  // Is any AVAILABLE variant reachable if this option value were chosen,
  // holding the shopper's other choices fixed? Used to mark dead combinations
  // up front instead of letting someone pick a size and hit a disabled button.
  function valueReachable(groupName, value) {
    if (singleStockBundles) {
      var size = groupName === 'opt-size' ? value : chosen('opt-size');
      var color = groupName === 'opt-color' ? value : chosen('opt-color');
      // The offer has no independent inventory. Do not dim every size/colour
      // just because the retired two-pair variant has zero stock.
      return variants.some(function (v) {
        return v.pairs === 1 && hasStock(v, 1) && (!size || v.size === size) && (!color || v.color === color);
      });
    }
    var others = ['opt-color', 'opt-size', 'opt-bundle']
      .filter(function (n) { return n !== groupName; })
      .map(chosen)
      .filter(Boolean);
    return variants.some(function (v) {
      if (!v.available || v.options.indexOf(value) === -1) return false;
      return others.every(function (o) { return v.options.indexOf(o) !== -1; });
    });
  }

  function markUnavailable() {
    ['opt-color', 'opt-size', 'opt-bundle'].forEach(function (group) {
      $$('input[name="' + group + '"]', form).forEach(function (input) {
        var dead = !valueReachable(group, input.value);
        var label = input.closest('label');
        if (label) label.classList.toggle('is-unavailable', dead);
        // aria-disabled, not disabled: a disabled radio cannot be focused, which
        // would strand a keyboard user on a dead combination with no way back.
        input.setAttribute('aria-disabled', dead ? 'true' : 'false');
      });
    });
  }

  // Colourway changes should change the picture. Each variant carries its own
  // media id; find the gallery frame with that id and select it.
  function syncMedia(v) {
    if (!v || !v.media) return;
    var target = $('[data-media-id="' + v.media + '"]');
    if (target && !target.checked) { target.checked = true; updateGalleryStatus(); }
  }

  function sync() {
    var v = match();
    syncExtra();
    markUnavailable();
    var isStockBundle = singleStockBundles && selectedPairs() === 2;
    var selection = isStockBundle ? bundleSelection() : null;
    // Colour previews work before size selection, without choosing a variant to buy.
    var color = chosen('opt-color');
    if (color) syncMedia(v || variants.find(function (item) { return item.options.indexOf(color) !== -1 && item.media; }));

    // The payment line under the button must never promise cash on delivery
    // for the 3-pack, which is prepaid only. Depends on the bundle alone, so it
    // runs even before a size is chosen.
    var payEl = $('[data-pay]', section);
    if (payEl) {
      var bl = form.querySelector('input[name="opt-bundle"]:checked');
      var pw = bl ? bl.closest('[data-pairs]') : null;
      var pp = pw ? parseInt(pw.dataset.pairs, 10) : 1;
      payEl.textContent = pp === 3 ? (payEl.dataset.prepaid || payEl.textContent)
                                   : (payEl.dataset.cod || payEl.textContent);
    }

    // echo the chosen value beside each label ("المقاس 40"), like a size tag
    $$('[data-chosen]', form).forEach(function (el) { el.textContent = optionLabel(chosen(el.dataset.chosen) || ''); });

    if (!v) {
      if (idField) idField.value = '';
      // A disabled button that still says "order now" explains nothing. Wear
      // the instruction instead.
      if (cta) { cta.disabled = true; cta.textContent = cta.dataset.pick || cta.textContent; }
      if (stickyCta) { stickyCta.disabled = addPending; stickyCta.textContent = stickyCta.dataset.pick || stickyCta.textContent; }
      var note = $('[data-size-note]', section);
      // Only prompt once the shopper has actually engaged — sync() also runs on
      // load, which showed "choose a size first" in error colour before they had
      // touched anything.
      if (note) note.hidden = !touched;
      var soldIdle = $('[data-sold-note]', section);
      if (soldIdle) soldIdle.hidden = true;
      // Reset to the base price; leaving the previous combination's price beside
      // a dead button misstates what the shopper would pay.
      if (basePrice) priceEls.forEach(function (el) { el.textContent = basePrice; });
      return;
    }
    var note2 = $('[data-size-note]', section);
    if (note2) note2.hidden = true;

    if (idField) idField.value = isStockBundle ? (selection.first ? selection.first.id : '') : v.id;
    priceEls.forEach(function (el) { el.textContent = v.priceText; });
    syncMedia(isStockBundle ? selection.first : v);
    var available = isStockBundle ? selection.available : v.available;
    var missingExtra = isStockBundle && selection.missing;
    if (cta) {
      cta.disabled = addPending || !available;
      cta.textContent = addPending ? (cta.dataset.adding || cta.textContent) :
        missingExtra ? form.dataset.pickExtra : available ? (cta.dataset.label || cta.textContent) : (cta.dataset.soldout || cta.textContent);
    }
    if (stickyCta) {
      stickyCta.disabled = addPending || !available;
      stickyCta.textContent = missingExtra ? form.dataset.pickExtra : available ? (stickyCta.dataset.ready || stickyCta.textContent)
                                          : (cta && cta.dataset.soldout) || stickyCta.textContent;
    }
    // Sold out is explained in words, never by the dimmed swatch alone.
    var soldNote = $('[data-sold-note]', section);
    if (soldNote) soldNote.hidden = available || missingExtra;
    try {
      var url = new URL(window.location);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    } catch (e) { /* not important enough to break anything */ }
  }

  if (cta) cta.dataset.label = cta.textContent.trim();
  form.addEventListener('change', function (e) {
    if (e.target.name === 'opt-size' || e.target.name === 'opt-bundle' || e.target.name === 'opt-color' || e.target.hasAttribute('data-extra-select')) {
      if (cartError) cartError.hidden = true;
      touched = true;
      sync();
    }
  });
  sync();
  $$('fieldset[data-option-field]', form).forEach(function (field) { field.disabled = false; });
  $$('option[data-requires-js]', form).forEach(function (option) { option.disabled = singleStockBundles || option.dataset.available !== 'true'; });
  section.classList.add('is-enhanced');

  /* ---- submit ---- */
  form.addEventListener('submit', function (e) {
    if (addPending) { e.preventDefault(); return; }
    var isStockBundle = singleStockBundles && selectedPairs() === 2;
    var selection = isStockBundle ? bundleSelection() : null;
    if (isStockBundle && (!match() || !selection.available)) {
      e.preventDefault();
      sync();
      showAddError(selection.missing ? form.dataset.pickExtra : (cta.dataset.soldout || form.dataset.errorMsg));
      return;
    }
    if (isStockBundle && !window.fetch) {
      e.preventDefault();
      showAddError(form.dataset.errorMsg);
      return;
    }
    if (!window.fetch || !idField.value) return;   // let the browser post it
    e.preventDefault();
    if (cartError) cartError.hidden = true;
    addPending = true;
    form.setAttribute('aria-busy', 'true');
    sync();

    var body = new FormData(form);
    if (isStockBundle) {
      body = new FormData();
      var items = [{ id: selection.first.id, quantity: selection.first.id === selection.second.id ? 2 : 1 }];
      if (selection.first.id !== selection.second.id) items.push({ id: selection.second.id, quantity: 1 });
      items.forEach(function (item, i) {
        body.append('items[' + i + '][id]', String(item.id));
        body.append('items[' + i + '][quantity]', String(item.quantity));
      });
      // The Fit Finder describes the first pair. Do not copy its measurement
      // or obsolete "Pair 2" properties onto a different second variant.
      var fit = form.querySelector('input[name="properties[_fit]"]');
      if (fit && fit.value) body.append('items[0][properties][_fit]', fit.value);
    }
    addCartItem(body)
      .then(persistGroup)
      .then(readCart)
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        renderDrawer(cart);
        openDrawer();
        announce(form.dataset.addedMsg || '');
        addPending = false;
        form.removeAttribute('aria-busy');
        sync();
      })
      .catch(function (err) {
        if (err && err.addFailed) {
          if (isStockBundle) {
            // Shopify can add the remaining stock while returning 422. A
            // failed multi-add is not an atomic rollback: show the real cart
            // without retrying or erasing anything the shopper already had.
            return readCart().then(function (cart) {
              $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
              renderDrawer(cart);
              var notice = document.createElement('p');
              notice.className = 'jz-field__note';
              notice.setAttribute('data-cart-stock-notice', '');
              notice.setAttribute('role', 'alert');
              notice.textContent = form.dataset.bundleStockError || err.message;
              var drawerBody = drawer && $('[data-drawer-body]', drawer);
              if (drawerBody) drawerBody.insertBefore(notice, drawerBody.firstChild);
              openDrawer();
              addPending = false;
              form.removeAttribute('aria-busy');
              sync();
              showAddError(err.message);
            }).catch(function () { window.location.href = cartUrl(); });
          }
          addPending = false;
          form.removeAttribute('aria-busy');
          sync();
          showAddError(err.message);
        } else window.location.href = cartUrl();
      });
  });

  /* ---- sticky mobile add-to-cart bar ----
     Delegates to the real CTA rather than being a second submit path, so the
     existing variant-required validation and add-to-cart flow above stay the
     single source of truth. Shown only once the real CTA has scrolled out of
     view above the viewport — not before the shopper has reached it. */
  if (stickyBar && cta) {
    stickyCta.addEventListener('click', function () {
      // A disabled button never dispatches a click — including a programmatic
      // one — so delegating straight to cta.click() would silently do nothing
      // while no variant is picked yet. Guide the shopper back to the picker
      // instead of failing quietly.
      if (!idField.value) { form.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      cta.click();
    });
    // Show whenever the real button is off screen — including BEFORE the
    // shopper has scrolled down to it. The buy button sits over a screen below
    // the fold on a phone, so gating this on "scrolled past" left the entire
    // first stretch of the page with no way to buy.
    //
    // Deliberately a scroll listener rather than IntersectionObserver: IO's
    // initial callback for an already-off-screen target did not fire in
    // testing, which left the bar hidden exactly when it was needed most.
    // A rAF-throttled scroll read is cheap and its initial state is explicit.
    // No requestAnimationFrame throttle here on purpose: rAF is paused while the
    // tab is backgrounded, which left the bar stuck in whatever state it had
    // when the tab lost focus. One rect read per scroll event is cheap, and
    // writing `hidden` only on an actual change avoids needless style recalcs.
    function syncSticky() {
      var r = cta.getBoundingClientRect();
      var ctaOnScreen = r.bottom > 0 && r.top < window.innerHeight;
      if (stickyBar.hidden !== ctaOnScreen) stickyBar.hidden = ctaOnScreen;
    }
    syncSticky();
    window.addEventListener('scroll', syncSticky, { passive: true });
    window.addEventListener('resize', syncSticky);
  }

})();
